<template>
  <div class="d-flex align-center" data-locator="document-viewer-header">
    <ClosdFildersIcon :document="file" class="mr-1" style="min-width: 0px" />
    <AppTooltip>
      <template #activator="{ props }">
        <span v-bind="props" class="text-bold text-grey-900 text-truncated mr-5">
          <span v-if="file.numbering" class="mr-1" data-locator="file-numbering">{{ file.numbering }}</span>
          <span data-locator="file-name">{{ file.name }}</span>
        </span>
      </template>
      <span>
        <template v-if="file.numbering">{{ file.numbering }}</template>
        {{ file.name }}
      </span>
    </AppTooltip>
    <app-badge v-if="file.version > 1" class="mr-1" data-locator="file-version">{{ `v${file.version}` }}</app-badge>

    <v-spacer />

    <template v-if="isRedactMode">
      <app-button
        data-locator="cancel-button"
        type="outlined"
        variant="neutral"
        @click="$emit('close')"
      >
        {{ $t('common.cancel') }}
      </app-button>
      <app-button
        class="ml-4"
        data-locator="save-button"
        type="primary"
        :disabled="isRedactButtonDisabled"
        @click="openRedactDocumentDialog"
      >
        {{ $t('common.register') }}
      </app-button>
    </template>
    <AppDownloadFile v-else-if="file.id && file.canDownload" :link="fileLink">
      <template #default="{ submitForm }">
        <app-button
          v-if="$vuetify.display.mdAndUp"
          type="primary"
          class="ml-5"
          :disabled="file?.canDownload === false"
          data-locator="download-button"
          @click="downloadFile(submitForm)"
        >
          {{ $t('common.DocumentViewer.downloadLabel') }}
        </app-button>
        <!-- The width of this button should match its height -->
        <app-button
          v-else
          style="width: 40px;"
          type="primary"
          data-locator="download-button"
          @click="submitForm"
        >
          <app-icon-ds icon="arrow-down-to-line" />
        </app-button>
      </template>
    </AppDownloadFile>
  </div>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'
  
  import AppDownloadFile from '@/common/AppDownloadFile.vue'
  import AppTooltip from '@/common/AppTooltip.vue'
  import ClosdFildersIcon from '@/common/filders/ClosdFildersIcon.vue'
  import { roomFileDownloadUrl } from '@/common/utils/files'
  import { DocumentViewerMutationTypes } from '@/store/modules/document-viewer/mutation_types'
  
  import { getPdfContentType, USER_ROLE, track } from '../pendo/agent'
  
  export default {
    name: 'DocumentViewerHeader',
    components: {
      AppDownloadFile,
      AppTooltip,
      ClosdFildersIcon,
    },
    props: {
      file: {
        type: Object,
        required: true,
      },
      mnemo: {
        type: String,
        required: true,
      },
      isRedactMode: {
        type: Boolean,
        default: false,
      },
      isRedactButtonDisabled: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      ...mapGetters('room', ['isCurrentUserPm']),
      fileLink () {
        return roomFileDownloadUrl(this.file.id, this.mnemo)
      },
    },
    methods: {
      ...mapMutations('documentViewer', [DocumentViewerMutationTypes.SET_REDACT_DOCUMENT_DIALOG]),
      openRedactDocumentDialog () {
        this.SET_REDACT_DOCUMENT_DIALOG(true)
      },
      downloadFile (callback) {
        track('document_downloaded', {
          document_id: this.file.id,
          project_mnemo: this.mnemo,
          user_role: this.isCurrentUserPm ? USER_ROLE.PROJECT_MANAGER : USER_ROLE.GUEST,
          document_type: this.file.ext,
          entrypoint: 'viewer_button',
          pdf_content_type: getPdfContentType(this.file),
        })
        callback()
      },
    },
  }
</script>
